import { ApolloError, QueryResult, useQuery } from '@apollo/client';
import { ActivityTypes } from 'types';
import GET_MATCH_IT_TRASH_IT_ACTIVITY from '../../queries/activities/match-it-trash-it-query';
import GET_STARTING_SOUND_ACTIVITY from '../../queries/activities/starting-sound-query';
import GET_WET_DRY_TRY_ACTIVITY from '../../queries/activities/wet-dry-try-query';

const lightRouteActivityQueryDict = {
  [ActivityTypes.MATCH_IT_TRASH_IT]: GET_MATCH_IT_TRASH_IT_ACTIVITY,
  [ActivityTypes.STARTING_SOUND]: GET_STARTING_SOUND_ACTIVITY,
  [ActivityTypes.WDT]: GET_WET_DRY_TRY_ACTIVITY,
};

const lightRouteActivityQueryNameDict = {
  [ActivityTypes.MATCH_IT_TRASH_IT]: 'matchItTrashIt',
  [ActivityTypes.STARTING_SOUND]: 'startingSound',
  [ActivityTypes.WDT]: 'wetDryTry',
};

export type LightRouteActivityState = {
  activity: any;
  error: ApolloError | undefined;
  isLoading: boolean;
};
export type LightRouteActivityDispatch = undefined;
export type LightRouteActivity = [LightRouteActivityState, LightRouteActivityDispatch];

const DEFAULT_EDITION = 2022;

const useLightRouteActivityStore = (activity: string, bookCode: string, edition?: number) => {
  const { data, loading, error }: QueryResult<{ [queryName: string]: any | undefined }> = useQuery(
    lightRouteActivityQueryDict[activity],
    {
      variables: { where: { book: { bookCode, edition: edition ?? DEFAULT_EDITION } } },
    }
  );

  return [
    {
      activity: data ? data[lightRouteActivityQueryNameDict[activity]] : null,
      error,
      isLoading: loading,
    },
    undefined,
  ];
};

export default useLightRouteActivityStore;
